import image1 from '../../assets/img/gallery/1.jpg';

const BlogsDetailsData = [
  {
    id: 1,
    href: "empowering-agri-industrial-growth",
    title: "Empowering Agri-Industrial Growth Through Innovation",
    breadcrumb: { title: "Empowering Agri-Industrial Growth Through Innovation" },
    date: "Apr 25, 2025",
    author: "Shree Gita Group",
    tags: [
      { tag: "Agricultural Innovation", href: "/blog/1" },
      { tag: "Industrial Solutions", href: "/blog/1" },
      { tag: "Warehousing", href: "/blog/1" },
      { tag: "Global Sourcing", href: "/blog/1" },
      { tag: "Edible Oils", href: "/blog/1" },
      { tag: "Cotton Industry", href: "/blog/1" },
    ],
    socialLinks: [
      { platform: "Facebook", icon: "fa-brands:facebook-f", href: "/" },
      { platform: "LinkedIn", icon: "fa-brands:linkedin-in", href: "/" },
      { platform: "Twitter", icon: "fa-brands:twitter", href: "/" }
    ],
    bannerImage: image1,
    meta: {
      title: "Driving Agricultural and Industrial Progress | Shree Gita Group",
      keywords: "Agricultural solutions, Industrial processing, Edible oil manufacturer India, Raw cotton supplier, Oilseeds exporter, Warehousing and distribution India, Shree Gita Group blog",
      description: "Discover how Shree Gita Group is empowering industries globally with premium agricultural and industrial products through innovation, sustainability, and trust."
    },
    content: [
      {
        heading: "A Legacy of Excellence",
        text: "With over 49 years of experience, Shree Gita Group has established itself as a leader in delivering high-quality agricultural and industrial products. From raw cotton and oilseeds to edible oils and de-oiled cakes, our journey has been defined by commitment, quality, and trust."
      },
      {
        heading: "Innovation at Every Step",
        text: "Our advanced processing and refining techniques ensure that we produce consistent and premium-quality products. With continuous R&D and modern technology, we enhance both productivity and sustainability in every stage—from sourcing to delivery."
      },
      {
        text: "Key innovations that drive our success:",
        list: [
          "State-of-the-art refining facilities for edible oils",
          "Automated seed cleaning and grading systems",
          "Eco-conscious de-oiling processes",
          "Real-time supply chain tracking and logistics",
          "Customized product development for client-specific needs",
          "Sustainability-focused sourcing and processing"
        ]
      },
      {
        heading: "Warehousing & Logistics",
        text: "To maintain product quality and ensure timely global delivery, we operate state-of-the-art warehousing and logistics infrastructure. This enables seamless storage and supply chain solutions, giving our clients peace of mind and reliability."
      },
      {
        heading: "Customization & Client Focus",
        text: "We offer flexible product solutions tailored to our clients’ unique needs—whether it's a specific oil blend, packaging, or distribution preference. Our customer-centric approach ensures satisfaction and long-term partnerships."
      },
      {
        heading: "Global Reach, Local Insight",
        text: "Serving clients across continents, we understand regional requirements and adapt our offerings accordingly. Whether you are a large-scale industry or a local business, Shree Gita Group delivers quality you can trust—anywhere in the world."
      },
      {
        text: (
          <>
            Explore more about our product range and services at{" "}
            <a href="https://shreegita.com" target="_blank" rel="noopener noreferrer">
              www.shreegita.com
            </a>{" "}
            and discover how we’re shaping the future of agri-industrial supply with innovation and integrity.
          </>
        )
      },
    ]
  }
];

export default BlogsDetailsData;
